import { OP } from './src/constants';

/**
 * mapea todos los filtros de un filter model en un objeto criteria
 * @param {object} filterModel
 * @returns {criteria[{v1, op, v2}]}
 */
export function mapFilterModelToCriterias(filterModel) {
  return Object.entries(filterModel).reduce((acc, [v1, models = {
      /* type:{string}, conditions{object[{condition, value}]} */}]) => {
    Object.values(models).forEach(conditions => {
      return conditions.forEach(({ condition: op, value: v2 }) => {
        if ([OP.IN, OP.NOT_IN].includes(op)) {
          // para "IN" y "NOT_IN" transformamos v2 de array a comalista:
          if (!v2.length) {
            // si no hay valores, lo filtramos
            return;
          }
          v2 = v2.join(',');
        }

        acc.push({ v1, op, v2 });
      });
    });
    return acc;
  }, []);
}
